import React from "react";
import { getTransferNFTTransaction } from "../../helpers/transactions";
import * as Dapp from "@elrondnetwork/dapp";

const TransferItem = ({ nftDetails }) => {
    const { address } = Dapp.useContext();
    const send = Dapp.useSendTransaction();

    const [receivingAddress, setReceivingAddress] = React.useState("");
    const handleSendButton = (e) => {
        e.preventDefault();
        // nu uita sa-i dai parse aici
        let quantity = parseInt("1"); 

        let sendTransaction = getTransferNFTTransaction(nftDetails.collection, nftDetails.nonce, quantity, address, receivingAddress);
        send({
            transaction: sendTransaction,
            callbackRoute: "/transaction"
        });
    };
    return (
        <section className="item-details-area">
            <div className="container">
                <div className="row justify-content-between">
                    <div className="col-12">
                        <div className="item-info">
                            <div className="item-thumb text-center col-12 col-lg-4 offset-lg-4">
                                <img src={nftDetails?.url ?? nftDetails.uris[0]} alt="" className="w-50" />
                            </div>

                        </div>
                    </div>
                    <div className="col-12 mt-5">

                        {/* Content */}
                        <div className="content mt-5 mt-lg-0 text-center">

                            <h1 className="m-0"> Transfer Item </h1>

                            <h3 className="mt-4">{nftDetails.name}</h3>
                            {/* <p>{this.state.initData.content}</p> */}

                            <div className="owner d-flex align-items-center mt-5">

                                <input type="text" placeholder="erd address" className="form-control" onChange={(e) => setReceivingAddress(e.target.value)} />

                            </div>

                            <div className="owner text-center mt-5">

                                <a className="btn btn-bordered-white btn-smaller mt-3" onClick={handleSendButton}>
                                    <i className="icon-envelope mr-2" />Send
                                </a>

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}

export default TransferItem;